import React from 'react'

interface ButtonProps {
  children: React.ReactNode
  onClick?: (e?: any) => void
  className?: string
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  style?: {}
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  className = '',
  type = 'button',
  disabled = false,
  style = {}
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`rounded-lg text-white font-medium transition duration-200 ease-in-out 
      ${disabled ? 'disabled:!bg-[#0000001f] disabled:!text-[#00000042] cursor-not-allowed' : ''} ${className}`}
      style={style}
    >
      {children}
    </button>
  )
}

export default Button
